import { SATOSPortal } from "@/data-adapter/SATOSPortal";
import { Group, GroupResources } from "@/features/groups/model/group/Group";
import { useQuery } from "@tanstack/react-query";

import { GetUserGroupMembershipStatusResponse } from "@/model/User/Employee";

export const useFetchGroups = () => {
	return useQuery<Group[]>({
		queryKey: [GroupQueryKeys.groups],
		queryFn: async () => {
			const groups = await SATOSPortal.GetGroups();
			return Array.isArray(groups) ? groups : [];
		},
	});
};

export const useFetchGroup = (groupId: number) => {
	return useQuery<Group>({
		queryKey: [GroupQueryKeys.groups, groupId],
		queryFn: () => SATOSPortal.GetGroup(groupId),
	});
};

export const useFetchUserGroupMembershipStatus = (
	groupId: number,
	options?: { enabled?: boolean },
) => {
	return useQuery<GetUserGroupMembershipStatusResponse>({
		queryKey: [GroupQueryKeys.groups, groupId, GroupQueryKeys.members],
		queryFn: () => SATOSPortal.GetUserGroupMembershipStatus(groupId),
		enabled: options?.enabled ?? true,
	});
};

export const useFetchGroupResources = (groupId: number) => {
	return useQuery<GroupResources>({
		queryKey: [GroupQueryKeys.groups, groupId, GroupQueryKeys.resources],
		queryFn: () => SATOSPortal.GetGroupResources(groupId),
	});
};

export class GroupQueryKeys {
	static readonly groups = "groups";
	static readonly members = "members";
	static readonly resources = "resources";
}
